import { render, staticRenderFns } from "./event-categories.vue?vue&type=template&id=3356ff54&"
import script from "./event-categories.vue?vue&type=script&lang=js&"
export * from "./event-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports